import React, { useEffect } from 'react';
import { Scene3D } from '../components/Scene3D/Scene3D';
import { Toolbar } from '../components/ui/Toolbar';
import { ObjectLibrary } from '../components/ui/ObjectLibrary';
import { SceneHierarchy } from '../components/ui/SceneHierarchy';
import { PropertyPanel } from '../components/ui/PropertyPanel';
import { useVisualizationStore } from '../stores';

export const VisualizationPage: React.FC = () => {
  const {
    sidebarCollapsed,
    panels,
    propertiesPanelWidth,
    objectLibraryWidth,
    generateMockData,
    createScene,
    loadScene,
  } = useVisualizationStore();

  // Initialize mock data and default scene on mount
  useEffect(() => {
    generateMockData();

    // Create and load a default scene
    const defaultSceneId = createScene({
      name: 'Default Scene',
      objects: [],
      settings: {
        backgroundColor: '#f0f0f0',
        showGrid: true,
        gridSize: 50,
        gridDivisions: 50,
        shadows: true,
        showAxes: false,
        units: 'metric',
        ambientLight: { intensity: 0.4, color: '#ffffff' },
      },
      camera: {
        position: [10, 10, 10],
        target: [0, 0, 0],
        fov: 50,
        near: 0.1,
        far: 1000,
      },
    });

    loadScene(defaultSceneId);
  }, [generateMockData, createScene, loadScene]);

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Left Sidebar */}
      {!sidebarCollapsed && (
        <div className="flex flex-col bg-white border-r border-gray-200" style={{ width: objectLibraryWidth }}>
          {/* Object Library */}
          {panels.objectLibrary && (
            <div className="flex-1 min-h-0">
              <ObjectLibrary />
            </div>
          )}

          {/* Scene Hierarchy */}
          {panels.hierarchy && (
            <div className="flex-1 min-h-0 border-t border-gray-200">
              <SceneHierarchy />
            </div>
          )}
        </div>
      )}

      {/* Main Content */}
      <div className="flex flex-col flex-1 min-w-0">
        {/* Toolbar */}
        <Toolbar />

        {/* 3D Scene */}
        <div className="flex-1 min-h-0">
          <Scene3D />
        </div>
      </div>

      {/* Right Sidebar */}
      {panels.properties && (
        <div className="bg-white border-l border-gray-200" style={{ width: propertiesPanelWidth }}>
          <PropertyPanel />
        </div>
      )}
    </div>
  );
};
